import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import { getAuthKind } from '@/utils/authState';
import { isInApp } from '@/utils/runtimeContext';

// Where "home" is for this visitor: the app home if they have any session.
export const homeTarget = () => (getAuthKind() ? '/home' : '/');

/**
 * Floating "Home" pill for public share pages, so someone who opened a
 * link straight into the app always has a way back to the main screen.
 */
export function ShareHomeButton() {
  const navigate = useNavigate();
  if (!getAuthKind() && !isInApp()) return null;
  return (
    <button
      type="button"
      onClick={() => navigate(homeTarget(), { replace: true })}
      className="fixed right-4 z-50 flex items-center gap-1.5 rounded-full px-3.5 py-2 text-sm font-medium shadow-lg backdrop-blur-md transition-transform hover:scale-[1.03] active:scale-95"
      style={{
        top: 'calc(var(--safe-area-top, env(safe-area-inset-top, 0px)) + 12px)',
        background: 'rgba(15, 23, 42, 0.72)',
        color: '#f8fafc',
        border: '1px solid rgba(255,255,255,0.14)',
      }}
      aria-label="Go to home"
      data-testid="share-home-btn"
    >
      <Home className="h-4 w-4" /> Home
    </button>
  );
}
